var styles = {
  "VisuallyHidden": "Polaris-VisuallyHidden"
};

export { styles as default };
